import { msg } from "@lingui/core/macro";
import { useLingui } from "@lingui/react";
import { useCallback, useState } from "react";
import { callAPI } from "../../../../utils/api";
import { RoleReward } from "../../../../utils/constants/types";
import { useDiscordUser } from "../../../../utils/hooks/useDiscordUser";
import { useErrorToast } from "../../../../utils/showToast";

const DISCORD_REFRESH_REWARDS_FAILED = msg({
  id: "Discord_refresh_rewards_failed",
  message: "Failed to refresh rewards: {errorMessage}",
});

export default function useRefreshRewards(refreshCallback: () => void) {
  const { mutate } = useDiscordUser();
  const showErrorToast = useErrorToast();
  const { _: i18n } = useLingui();
  const [isLoading, setIsLoading] = useState(false);
  const [newRoles, setNewRoles] = useState<RoleReward[]>([]);

  const refreshRewards = useCallback(() => {
    setIsLoading(true);
    setNewRoles([]);

    callAPI(["discord", "reward"], { method: "POST" })
      .catch((e) =>
        showErrorToast(
          i18n(DISCORD_REFRESH_REWARDS_FAILED.id, {
            errorMessage: e instanceof Error ? e.message : String(e),
          })
        )
      )
      .then((res) => {
        if (res?.length > 0) {
          setNewRoles(res);
          refreshCallback();
        }
      })
      .finally(() => {
        setIsLoading(false);
        mutate();
      });
  }, [i18n, mutate, refreshCallback, showErrorToast]);

  return {
    refreshRewards,
    isLoading,

    newRoles,
  };
}
